var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_238_248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6888 4.69058L13.8123 7.56713C13.6048 7.77461 13.3329 7.87834 13.0609 7.87834C12.789 7.87834 12.5171 7.77461 12.3096 7.56713C11.8947 7.15219 11.8947 6.47946 12.3096 6.06452L13.3724 5.00179H2.23291C1.64611 5.00179 1.17041 4.52609 1.17041 3.93929C1.17041 3.35249 1.64611 2.87679 2.23291 2.87679H13.3724L12.3096 1.81406C11.8947 1.39912 11.8947 0.726388 12.3096 0.311449C12.7246 -0.103491 13.3973 -0.103491 13.8123 0.311449L16.6888 3.188C17.1037 3.60291 17.1037 4.27567 16.6888 4.69058ZM14.186 11.9987H3.62761L4.69037 10.9359C5.10528 10.521 5.10528 9.84828 4.69037 9.43334C4.2754 9.0184 3.60271 9.0184 3.18773 9.43334L0.31118 12.3099C-0.103727 12.7248 -0.103727 13.3976 0.31118 13.8125L3.18773 16.6891C3.39522 16.8965 3.66712 17.0003 3.93905 17.0003C4.21099 17.0003 4.48289 16.8965 4.69037 16.6891C5.10528 16.2741 5.10528 15.6014 4.69037 15.1864L3.62761 14.1237H14.186C14.7728 14.1237 15.2485 13.648 15.2485 13.0612C15.2485 12.4744 14.7728 11.9987 14.186 11.9987Z",
    fill: "#2395FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchBlue);
export default __webpack_public_path__ + "static/media/switchBlue.84f0c7cf8e1a71266adfef23e5925413.svg";
export { ForwardRef as ReactComponent };